const rate = {
  path: 'rate',
  component: resolve => require(['@/pages/admin/merchant/signing/yftWeChat/rate'], resolve),
  meta: {isRate: true}
}

export default rate
